import { render } from "./WindowTypes.vue?vue&type=template&id=89299ed6"
import script from "./WindowTypes.vue?vue&type=script&lang=js"
export * from "./WindowTypes.vue?vue&type=script&lang=js"

import exportComponent from "F:\\PROMODUL\\Projets\\APP.LUMIERE+\\code\\lumiere_plus\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__